module.exports = __webpack_public_path__ + "img/vip-img4.fe322dd6.png";